export class TemplateStateModel {
    templates!: {};
    activePage!: number;
}